"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionButtonBaseCss = exports.ActionButton = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokens = require("@smartsheet/design-tokens");
var _createFocusRingStyles = require("../../../../util/createFocusRingStyles");
var _clickable = require("../../../clickable");
var _formInputTheme = require("../../../textinput/styled/formInputTheme");
var _selectV2Theme = require("../selectV2Theme");
const ActionButtonBaseCss = _ref => {
  let {
    themeMode
  } = _ref;
  return {
    display: "inline-flex",
    alignItems: "center",
    boxSizing: "border-box",
    cursor: "pointer",
    height: _selectV2Theme.selectV2Theme.actionButtons.size(themeMode),
    width: _selectV2Theme.selectV2Theme.actionButtons.size(themeMode),
    margin: 0,
    // padding: `${sizes.xxSmall}px`,
    border: "none",
    borderRadius: _selectV2Theme.selectV2Theme.actionButtons.borderRadius(themeMode),
    fontWeight: 600,
    color: "currentColor",
    justifyContent: "space-around",
    whiteSpace: "nowrap",
    backgroundColor: "transparent",
    transition: `background-color ${_designTokens.motion.animation.default}`
  };
};
exports.ActionButtonBaseCss = ActionButtonBaseCss;
const ActionButton = (0, _styled.default)(_clickable.Clickable)`
    ${ActionButtonBaseCss}

    ${_ref2 => {
  let {
    omitFocusRing,
    themeMode
  } = _ref2;
  return omitFocusRing ? "" : (0, _createFocusRingStyles.createFocusRingStyles)({
    theme: themeMode,
    // We want these outlines to sit within the button's content box.
    gap: -2,
    focusSelector: ":focus-visible",
    componentBorderWidth: 0,
    componentRadius: _formInputTheme.formInputTheme.borderRadius(themeMode)
  });
}}
    background-color: ${_ref3 => {
  let {
    isHovered,
    isOpen,
    isActive,
    themeMode
  } = _ref3;
  if (isHovered && !isActive) {
    return `${_selectV2Theme.selectV2Theme.actionButtons.background.hover(themeMode)};`;
  }
  if (isOpen || isActive) {
    return `${_selectV2Theme.selectV2Theme.actionButtons.background.active(themeMode)};`;
  }
  return ``;
}}
`;
exports.ActionButton = ActionButton;
ActionButton.displayName = "ActionButton";
//# sourceMappingURL=ActionButton.js.map